qw-guest {
  --qw-guest-width: 60%;

  display: flex;
  flex-direction: column;
  width: var(--qw-guest-width);
  max-width: 334px;
  border: solid 2px var(--qw-hotel-neutral-medium);
  background-color: #ffffff;
  border-radius: 5px;
  padding: 33px 24px 43px;
}

qw-guest.qw-guest--center {
  margin: 0 auto;
}

qw-guest.qw-guest--disabled {
  opacity: var(--qw-hotel-opacity);
  pointer-events: none !important;
}

qw-guest .qw-guest__counter-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 43px;
}

qw-guest .qw-guest__counter-wrapper:nth-child(3) {
  margin-bottom: 0;
}

qw-guest .qw-guest__counter-wrapper:last-of-type {
  margin-bottom: 0;
}

qw-guest .qw-guest__counter-wrapper__label {
  margin-right: var(--qw-hotel-gap-md);
  font-size: 20px;
  font-family: var(--qw-hotel-font-family-m);
}

qw-guest .qw-guest__counter-wrapper__sublabel {
  font-size: 16px;
  color: var(--qw-hotel-label);
  font-family: var(--qw-hotel-font-family-r);
  margin: 0 !important;
}

.qw-group--link .qw-span--label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 43px;
}
.qw-group--link .qw-span--label .qw-input__label {
  font-size: 20px;
  font-family: var(--qw-hotel-font-family-m);
  color: var(--qw-hotel-neutral-medium);
  margin: 0 !important;
  max-width: 50%;
  white-space: normal;
}

.qw-group--link .qw-span--label span {
  font-size: 19px;
  margin-left: 12px;
  text-decoration: underline;
  cursor: pointer;
}

@media only screen and (max-width: 738px) {
  qw-guest {
    padding: var(--qw-hotel-gap-md);
    width: 100%;
    border: 0;
    border-radius: 0;
    border-top: 2px solid var(--qw-hotel-primary-color);
    box-shadow: 0px 0px 5px rgb(0 0 0 / 25%);
  }
  .qw-group--link .qw-span--label {
    margin-top: 16px;
  }
  .qw-group--link {
    margin: 4px 0;
  }

  .qw-group--link .qw-span--label .qw-input__label {
    font-family: var(--qw-hotel-font-family-b);
  }
  qw-guest .qw-guest__counter-wrapper {
    margin-bottom: var(--qw-hotel-gap-md);
  }
  qw-guest .qw-guest__counter-wrapper__label {
    font-family: var(--qw-hotel-font-family-b);
  }
  qw-guest .qw-guest__counter-wrapper__sublabel {
    display: none;
  }
  qw-guest qw-counter {
    padding: 4px 12px;
  }
}
